<template>
  <page-layout>
    <el-card>
      <div slot="header">
        <span>预警配置</span>
      </div>
      <p>预警配置页面内容</p>
    </el-card>
  </page-layout>
</template>

<script>
export default {
  name: 'AlertConfig'
}
</script>



